.articleLoginWall {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 500px;
  overflow: hidden;
}

.contentWrapper {
  z-index: var(--cxy-z-index-internal-base);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-family: 'Public Sans', sans-serif;
}

.backgroundContainer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  object-fit: fill;
  height: 500px;
  z-index: var(--cxy-z-index-hidden);
}

.title {
  margin: 16px 0px 8px;
  font-size: 20px;
  line-height: 24px;
  text-transform: uppercase;
  width: 100%;
  max-width: 350px;
  color: #052643;

  @media (min-width: 768px) {
    font-size: 24px;
    max-width: unset;
  }
}

.subtitle {
  font-weight: 600;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0px;
  color: #052643;
  margin: 0 0 20px;
  width: 100%;
  max-width: 600px;
  text-align: center;
  font-weight: 500;
  text-transform: uppercase;

  @media (min-width: 768px) {
    font-size: 16px;
  }
}

.bulletsWrapper {
  max-width: 350px;
  margin: 16px auto;

  @media (min-width: 768px) {
    max-width: 500px;
  }
}

.benefitBullet {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 6px;
  text-align: start;

  @media (min-width: 768px) {
    margin-bottom: 10px;
  }
}

.itemIcon {
  margin-top: 2px;
}

.itemTextWrapper {
  margin-left: 10px;
}

.itemHeader {
  font-size: 15px;
  font-weight: 500;
}

.itemBody {
  font-size: 14px;
  font-weight: 400;
  color: #6b7883;
}

.ctaWrapper {
  display: flex;
  flex-direction: column;
  margin: 8px 0 0;
  gap: 8px;
  @media (min-width: 768px) {
    flex-direction: row;
    gap: 16px;
  }

  > button {
    border-radius: 4px;
    width: 300px;
    height: 40px;
    margin: 4px 0px;
    text-transform: uppercase;
    transition:
      background-color 0.3s ease,
      box-shadow 0.3s ease,
      transform 0.2s;
    cursor: pointer;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      transform: translateY(-1px);
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 0 3px rgba(0, 232, 137, 0.4);
    }
  }
}

.primaryCta {
  background-color: var(--cxy-color-interactive-primary);

  &:hover {
    background-color: var(--cxy-color-interactive-primary-hover);
  }
}

.secondaryCta {
  border: 1px solid #6b7883;

  &:hover {
    background-color: #f0f4f8;
  }
}

/* replace with css vars from cxy */
